import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: 'transparent',
  },
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    marginRight: 40,
    fontWeight: 500,
    fontSize: 14,
  },
  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  left: {
    display: 'flex',
    alignItems: 'center',
  },
  tabs: {
    '& .MuiTabs-flexContainer': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  gridPaper: {
    height: '100%',
    padding: 0,
  },
  tabsPaper: {
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
  },
  tabsPanel: {
    width: '100%',
  },
  btnAdd: {
    boxShadow: theme.shadows[0],
    padding: theme.spacing(0, 1),
    marginLeft: theme.spacing(2),
    minWidth: 64,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#5081FF',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: 'rgb(0, 87, 178)',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    },
    '& svg': {
      fill: '#ffffff',
    },
  },
  tabBox: {
    margin: theme.spacing(3.5, 0, 0),
    '& > div > div': {
      padding: 0,
    },
  },
  tabBoxs: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiTabs-flexContainer': {
      display: 'flex',
      justifyContent: 'space-between',
    },
    // margin: theme.spacing(3.5, 0, 0),
    width: '100%',
    '& > div > div': {
      padding: 0,
    },
  },
}));
